function appVersionDirective(version) {
    'ngInject';

    return function (scope, elm, attrs) {
        elm.text(version);
    };
}

angular
    .module('BB')
    .directive('appVersion', appVersionDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/app-version/app_version.directive.js